/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from '../../Components/Utility/Loader/Loader';
import { getPCPLogs, clearPCPLogs, deletePCPLogs } from './store/ProductCP.action';
import './ProductCP.css';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';
import { getPreReadSignedWriteUrl } from '../../services/s3Services';

function ProductCPLogs() {
  const dispatch = useDispatch();
  const [pcpData, setPcpData] = useState([]);
  const history = useHistory();
  const listInnerRef = useRef();
  const reducers = useSelector((redState) => redState);
  const {
    ProductCPReducer: { pcpLogs, totalCount },
    Users: { logInRights },
  } = reducers;
  const { CheckActionPermission } = useComponent();

  const productDeleteAccess = CheckActionPermission(logInRights, 'criticalPath', 'product', 'delete');

  const { t } = useTranslation('common');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    pageNumber: 1,
    pageSize: 20,
    totalCount: 0,
    scrollLoader: false,
    hasMore: false,
    dataList: [],
    isDataLoaded: false,
  });
  const { pageNumber, pageSize } = state;

  const getPCP = async (page) => {
    setLoading(true);
    const reqObj = {
      pageNumber: page || pageNumber,
      pageSize,
    };
    await dispatch(getPCPLogs(reqObj));
    setLoading(false);
  };
  useEffect(() => {
    getPCP();
    return () => {
      dispatch(clearPCPLogs());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNextPageInScroll = async () => {
    const nextPageIndex = pageNumber + 1;
    setState((prevState) => ({
      ...prevState,
      pageNumber: nextPageIndex,
    }));

    const params = {
      pageNumber: nextPageIndex,
      pageSize,
    };

    dispatch(getPCPLogs(params));
  };

  useEffect(() => {
    if (pcpLogs?.length > 0) {
      setPcpData(pcpLogs);
      setState((prevState) => ({
        ...prevState,
        totalCount,
        hasMore: totalCount > pcpLogs?.length,
      }));
    }
  }, [pcpLogs, totalCount]);

  const getFileName = (fileUrl) => {
    if (!fileUrl) return '';
    const lastSegment = fileUrl.split('?')[0].split('/').pop();
    try {
      return decodeURIComponent(lastSegment);
    } catch {
      return lastSegment;
    }
  };

  const downloadFile = async (item) => {
    if (!item?.fileUrl) return;
    const isFullUrl = item.fileUrl.startsWith('http');
    let href = item.fileUrl;
    if (!isFullUrl) {
      const res = await getPreReadSignedWriteUrl({ objectKey: item.fileUrl });
      if (res?.code !== 200 || !res?.data) return;
      href = res.data;
    }
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', getFileName(item.fileUrl));
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  const handleBack = () => {
    history.push('/product-cp');
  };

  const deleteFiles = async (item) => {
    if (item?._id) {
      setLoading(true);
      const reqObj = {
        id: item?._id,
      };
      dispatch(clearPCPLogs());
      setPcpData([]);
      const res = await dispatch(deletePCPLogs(reqObj, t));
      if (res) {
        await getPCP(1);
      }
      setLoading(false);
    }
  };

  const itemStatus = (status) => {
    if (status === 'Finish') {
      return 'f-14  range-badge  badge badge-success';
    }
    if (status === 'Failed') {
      return 'f-14 range-badge  badge badge-danger';
    }
    return 'f-14 range-badge  badge badge-warning';
  };

  const getStatusText = (status) => {
    if (status === 'Finish') {
      return 'Completed';
    }
    return status;
  };

  return (
    <div>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <span className="title">{t('PRODUCT_CRITICAL_PATH.PRODUCT_CRITICAL_PATH_INDEX.PRODUCT_CRITICAL_PATH_LOGS')}</span>
        </div>

        <button type="button" aria-label="button" className="cursor-pointer p-0 d-inline-flex btn ml-auto" onClick={handleBack}>
          <i className="icon-close f-20" />
        </button>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div
          id="scrollableDiv_PIM"
          style={{
            height: 'calc(100vh - 135px)',
            overflowY: 'auto',
          }}
          ref={listInnerRef}
        >
          <InfiniteScroll
            dataLength={pcpData?.length}
            hasMore={state?.hasMore}
            next={handleNextPageInScroll}
            scrollableTarget="scrollableDiv_PIM"
            className="fixed-col-container"
          >
            <Container className="range-plan-logs" fluid>
              <Row>
                {pcpData?.length > 0 &&
                  pcpData?.map((item) => (
                    <div
                      id="accordion"
                      key={item?._id}
                      className="col-lg-4 "
                      onClick={() => {
                        setShow(!show);
                      }}
                      role="button"
                      tabIndex={0}
                    >
                      <div className="common-listing-card card mt-24">
                        <div className="card-header d-flex align-items-center">
                          <ul className="card-header-icon ml-auto">
                            <li>
                              <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.MULTI_SUBMIT_DOWNLOAD.DOWNLOAD_FILE')}>
                                <button
                                  className="btn p-0"
                                  type="button"
                                  aria-label="download"
                                  disabled={item?.status !== 'Finish'}
                                  onClick={() => downloadFile(item)}
                                >
                                  <i className="icon-download" />
                                </button>
                              </CustomTooltip>
                            </li>
                            {productDeleteAccess && (
                              <li>
                                <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.MULTI_SUBMIT_DOWNLOAD.DELETE')}>
                                  <button className="btn p-0" type="button" aria-label="delete" onClick={() => deleteFiles(item)}>
                                    <i className="icon-delete" />
                                  </button>
                                </CustomTooltip>
                              </li>
                            )}
                          </ul>
                        </div>
                        <div className="card-body">
                          <ul className="card-ul ">
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.DOWNLOAD_BY')}: </strong>
                              {item?.userId?.firstName} {item?.userId?.lastName}
                            </li>
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.LOG_DATE')}: </strong>
                              {item?.createdAt ? moment(item?.createdAt).format('DD-MMM-YYYY, HH:mm') : ''}
                            </li>
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.FILE')}: </strong>
                              {getFileName(item?.fileUrl)}
                            </li>
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.MODULES')}: </strong>
                              {item?.pcpId?.name}
                            </li>
                            {/* Product Type */}

                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_TYPES')}: </strong>
                              {item?.filterData?.productTypeDetails?.map((type) => type?.name).join(', ')}
                            </li>

                            {/* Season */}
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.SEASONS')}: </strong>
                              {item?.filterData?.seasonDetails?.map((season) => season?.name).join(', ')}
                            </li>

                            {/* Month */}
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.MONTHS')}: </strong>
                              {item?.filterData?.month?.join(', ')}
                            </li>

                            {/* Year */}
                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.YEARS')}: </strong>
                              {item?.filterData?.year?.join(', ')}
                            </li>

                            <li>
                              <strong>{t('RANGE_PLANS.PRODUCT_LIST.STATUS')}: </strong>
                              <span className={itemStatus(item?.status)}>{getStatusText(item?.status)}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))}
                {!loading && pcpData?.length === 0 && (
                  <Col lg={12} className="d-flex mt-16 justify-content-center">
                    {t('RANGE_PLANS.PRODUCT_LIST.NO_RECORD_FOUND')}
                  </Col>
                )}
              </Row>
            </Container>
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
}

export default ProductCPLogs;
